export default __webpack_public_path__ + "static/media/p10.69a0efed.png";